import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isLoading: false,
  loadingCount: 0,
  loadingMessage: 'Loading...',
  showOverlay: true
};

const globalLoaderSlice = createSlice({
  name: 'globalLoader',
  initialState,
  reducers: {
    showLoader: (state, action) => {
      state.loadingCount += 1;
      state.isLoading = true;
      state.loadingMessage = action.payload?.message || 'Loading...';
      state.showOverlay = action.payload?.showOverlay !== false;
    },
    hideLoader: (state) => {
      state.loadingCount = Math.max(0, state.loadingCount - 1);
      if (state.loadingCount === 0) {
        state.isLoading = false;
        state.loadingMessage = 'Loading...';
      }
    },
    resetLoader: (state) => {
      state.isLoading = false;
      state.loadingCount = 0;
      state.loadingMessage = 'Loading...';
      state.showOverlay = true;
    },
    setLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload;
    }
  }
});

export const {
  showLoader,
  hideLoader,
  resetLoader,
  setLoadingMessage
} = globalLoaderSlice.actions;

export default globalLoaderSlice.reducer;
